import Vue from 'vue';
import VueBridgeApp from './VueBridgeApp.vue';
import FontAwesomeIcon from '../plugins/font-awesome';

FontAwesomeIcon();

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(VueBridgeApp),
}).$mount('#vue-bridge-app');
